// @ts-nocheck
import { ref } from "vue";
import { event } from "vue-gtag";
import  pako from 'pako' 
import Big from 'big.js'

const errorMessages = ref([])
export function useHelpers() {
  const setErrorMessages = (array) => errorMessages.value = array;
  const logGAevent = (name, category, label) => {
    event(name, {
      event_category: category,
      event_label: label,
    });
  };

  const arrayFindObjectByProp = (arr, prop, val) => {
    return arr.find((obj) => obj[prop] == val);
  };

  const numberWithCommas = (x) => {
    if (x != undefined) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  };

 

  const m2ToAcres = (val) => {
    const acres = val * 0.000247105;
    if (acres > 1000) {
      return Math.round(acres);
    } else {
      return Math.round(acres * 10) / 10;
    }
  };

  const cellCount10mToAcres = (count) => {
    const ac = count * 100 * 0.000247105; // convert to m2 then acres
    return ac.toFixed(1);
  };

  const cellCount30mToAcres = (count) => {
    const ac = count * 900 * 0.000247105; // convert to m2 then acres
    return ac.toFixed(1);
  };

  const cellCount180mToAcres = (count) => {
    const ac = count * 32400 * 0.000247105; // convert to m2 then acres
    return ac.toFixed(1);
  };
  const cellCount250mToAcres = (count) => {
    const ac = count * 62500 * 0.000247105; // convert to m2 then acres
    return ac.toFixed(1);
  };
  const cellCount90mToAcres = (count) => {
    const ac = count * 8100 * 0.000247105; // convert to m2 then acres
    return ac.toFixed(1);
  };


  const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);

  const mToFeet = (m) => {
    return m * 3.28084;
  };

  

  const sumAllValuesInObject = (obj: Record<string, unknown>): number => {
    let count = 0;
    Object.values(obj).forEach((v) => {
      // Type assertion to number
      count += v as number;
    });
    return count;
  };

  
  const gcd = (x, y) => {
    if (x === 0) {
      return Math.abs(y); // If x is zero, return the absolute value of y
    } else if (y === 0) {
      return Math.abs(x); // If y is zero, return the absolute value of x
    } else {
      return y ? gcd(y, x % y) : x; // Otherwise, compute the GCD
    }
  };

  const sumArray = (vals) => {
    const sum = vals.reduce((acc, val) => acc + val, 0);
    return isNaN(sum) ? 0 : sum;
  };

  const titleCase = (st) => {
    return st
      .toLowerCase()
      .split(" ")
      .reduce(
        (s, c) => s + "" + (c.charAt(0).toUpperCase() + c.slice(1) + " "),
        ""
      );
  };

  const sigFig = (v, unit = null, precision = 2) => {
    if (isNaN(v)) {
      return v;
    }
    else if (!unit) {
      return v.toPrecision(precision);
    } 
    else if (unit == "ac") {
      return (v * 0.000247105).toPrecision(precision);
    }
  };

  
  // used to save a big result object to json, so can be uploaded to S3
  const saveObjToFile = (obj) =>{
    const jsonString = JSON.stringify(obj)
    const blob = new Blob([jsonString], {type: 'application/json'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'result.json';
    a.click();
    URL.revokeObjectURL;
  }
  
  const getZscore =(val, mean, sd) =>{
    return (val - mean) / sd;
  }

  const groupSort = (data, categories) => {
    // sort an array of objects by the largest value in a category.
    // So "Very High" presence first, then by "high presence", etc
    return data.sort((a, b) => {
      for (let category of categories) {
        if (b[category] !== a[category]) {
          return b[category] - a[category];
        }
      }
      return 0;
    });
  }

  const groupSortIndividBarArrays = (data, categories, groupByProp) => {
    // this takes an array of objects like the following and returns an array of arrays, one array for each sp.
    // THey are sorted based on the categories passed in, so that the sp with the most "Very High" come first.
    // Within each sp, the Very High object, also comes first
    // const data [
    //   { "sp": "Black Sea Bass", "category": "Absent", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "No Data", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "Present", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "Median", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "High", "value": 0 },
    //   { "sp": "Black Sea Bass", "category": "Very High", "value": 100 },
    //   { "sp": "Northern Searobin", "category": "Absent", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "No Data", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "Present", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "Median", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "High", "value": 0 },
    //   { "sp": "Northern Searobin", "category": "Very High", "value": 100 }
    // ];

    // Group the data by the specified property
    const groupedData = data.reduce((acc, item) => {
      if (!acc[item[groupByProp]]) {
        acc[item[groupByProp]] = [];
      }
      acc[item[groupByProp]].push(item);
      return acc;
    }, {});

    // Sort each group based on the categories array
    for (let group in groupedData) {
      groupedData[group].sort((a, b) => {
        for (let category of categories) {
          if (b.category === category && a.category !== category) {
            return 1;
          } else if (a.category === category && b.category !== category) {
            return -1;
          }
        }
        return 0;
      });
    }

    // Sort the groups based on the highest value in the specified categories
    const sortedGroups = Object.keys(groupedData).sort((a, b) => {
      for (let category of categories) {
        const aValue = groupedData[a].find(d => d.category === category)?.value || 0;
        const bValue = groupedData[b].find(d => d.category === category)?.value || 0;
        if (bValue !== aValue) {
          return bValue - aValue;
        }
      }
      return 0;
    });

    // Return the sorted groups as an array of arrays
    return sortedGroups.map(group => groupedData[group]);
  };

  const arrayMaxExcludingValue = (arr: number[], exclude: number) =>{
    // pass in an array, and get the max value, but not if it is the exclude value.  
    // useful if no data is a positive 99, for example, and want the max value excluding that
    const filteredArray = arr.filter(num => num !== exclude);
    // if the array is empty or the exclude value is the only one then return it
    if (filteredArray.length === 0 || arr.length === 1) {
        return exclude;
    }
    return Math.max(...filteredArray);
  }

  const getKeyByValue = (object, value) => {
    return Object.keys(object).find(key => object[key] === value);
  }

  const sortArrayByOrder = (arr, order, property) => {
    return arr.sort((a, b) => {
      let aIndex = order[a[property]];
      let bIndex = order[b[property]];
      if (aIndex === undefined) aIndex = Infinity;
      if (bIndex === undefined) bIndex = Infinity;
      return aIndex - bIndex;
    });
  }

  const isFloat =(n) =>{
    return n === +n && n !== (n|0);
  }

  const months = {
    "M01" : "Jan",
    "M02" : "Feb",
    "M03" : "Mar",
    "M04" : "Apr",
    "M05" : "May",
    "M06" : "Jun",
    "M07" : "Jul",
    "M08" : "Aug",
    "M09" : "Sep",
    "M10" : "Oct",
    "M11" : "Nov",
    "M12" : "Dec"
  };

  // const objToBase64 = (obj) =>{
  //   try{
  //     const jsonString = JSON.stringify(obj);
  //     const compressed = pako.deflate(jsonString);
  //     const base64String = btoa(String.fromCharCode.apply(null, new Uint8Array(compressed)));
  //     return base64String;
  //   }
  //   catch (error) {
  //       console.error('Compression error:', error);
  //       return null;
  //   }
  // }

  const arrayListToString = (arr) => {

    if (arr.length === 0) return 'None / No Data';
    if (arr.length === 1) return arr[0];
    if (arr.length === 2) return arr.join(' and ');
  
    const lastItem = arr.pop();
    return arr.join(', ') + ', and ' + lastItem;
  }

  const objToBase64 = (obj) => {
    try {
        const jsonString = JSON.stringify(obj);
        const chunkSize = 1024; // Define a suitable chunk size
        const deflator = new pako.Deflate();

        for (let i = 0; i < jsonString.length; i += chunkSize) {
            const chunk = jsonString.slice(i, i + chunkSize);
            deflator.push(chunk, i + chunkSize >= jsonString.length);
        }

        if (deflator.err) {
            throw new Error(deflator.msg);
        }

        const compressed = deflator.result;
        const uint8Array = new Uint8Array(compressed);
        const binaryString = Array.from(uint8Array).map(byte => String.fromCharCode(byte)).join('');
        const base64String = btoa(binaryString);
        return toUrlSafeBase64(base64String);
    } catch (error) {
        console.error('Compression error:', error);
        return null;
    }
};

const base64ToObj = (urlSafeBase64) => {
    try {
        const base64String = fromUrlSafeBase64(urlSafeBase64);
        // console.log('Base64 String:', base64String); // Add logging
        const binaryString = atob(base64String);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const decompressed = pako.inflate(bytes, { to: 'string' });
        const obj = JSON.parse(decompressed);
        return obj;
    } catch (error) {
        console.error('Decompression error:', error);
        return null;
    }
};

const toUrlSafeBase64 = (base64String) => {
    return base64String.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
};

const fromUrlSafeBase64 = (urlSafeBase64) => {
    let base64String = urlSafeBase64.replace(/-/g, '+').replace(/_/g, '/');
    while (base64String.length % 4) {
        base64String += '=';
    }
    return base64String;
};




  // const base64ToObj = (urlSafeBase64) =>{
  //   try{
  //     const base64String = fromUrlSafeBase64(urlSafeBase64);
  //     const binaryString = atob(base64String);
  //     const len = binaryString.length;
  //     const bytes = new Uint8Array(len);
  //     for (let i = 0; i < len; i++) {
  //         bytes[i] = binaryString.charCodeAt(i);
  //     }
  //     const decompressed = pako.inflate(bytes, { to: 'string' });
  //     const obj = JSON.parse(decompressed);
  //     return obj;
  //   }catch (error) {
  //       console.error('Decompression error:', error);
  //       return null;
  //   }

  // }

  const roundSigFig = (num, sigFigs) => {
    if (num === 0) return 0;

    const magnitude = Math.floor(Math.log10(Math.abs(num)));
    const multiplier = new Big(10).pow(sigFigs - magnitude - 1);

    const adjustedNum = new Big(num).times(multiplier).round().div(multiplier);

    return Number(adjustedNum);
  }


  const getMedian = (arr) => {
    // Sort the array in ascending order
    arr.sort((a, b) => a - b);
  
    const mid = Math.floor(arr.length / 2);
  
    // If the array has an even number of elements
    if (arr.length % 2 === 0) {
      return (arr[mid - 1] + arr[mid]) / 2;
    } else {
      // If the array has an odd number of elements
      return arr[mid];
    }
  }

  const getMean = (arr) => {
    if (arr.length === 0) return 0;
  
    let sum = 0;
    for (let i = 0; i < arr.length; i++) {
      sum += arr[i];
    }
  
    return sum / arr.length;
  }

  const getPropForLargestValue = (obj) => {
    // return the key for the largest value
    let largestValue = -Infinity;
    let largestKey = '';
  
    for (const key in obj) {
      if (obj[key] > largestValue) {
        largestValue = obj[key];
        largestKey = key;
      }
    }
    // return null if the laregst value is <=0
    return largestValue <= 1 ? null : largestKey;
  };

  const getPropsForLargestValue = (obj) => {
    // returns an array of keys.  Like getPropForLargestValue but returns all keys in the event of a tie
    // console.log(obj);
    let largestValue = -Infinity;
    let largestKeys = [];

    for (const key in obj) {
        if (obj[key] > largestValue) {
            largestValue = obj[key];
            largestKeys = [key];
        } else if (obj[key] === largestValue) {
            largestKeys.push(key);
        }
    }
    // return null if the largest value is <= 1
    return largestValue <= 0 ? {keys: null, value:0} : {keys: largestKeys, value:largestValue};
  };

  const containsSubstring = (substring, list) =>{
    return list.some(str => str.includes(substring));
  }


  const getBarCategoryWithLargestValue = (data) => {
    // Initialize variables to store the category with the largest value
    let maxValue = -1;
    let maxCategory = null;

    // Iterate over each item in the data
    data.forEach(item => {
        // Check if the current item's value is greater than the maxValue
        if (item.value > maxValue) {
            maxValue = item.value;
            maxCategory = item.category;
        }
    });

    return maxCategory;
  }


  const getMode = (arr) => {
      const frequency = {};
      let maxFreq = 0;
      let mode = [];

      // Calculate the frequency of each number
      for (let num of arr) {
          frequency[num] = (frequency[num] || 0) + 1;
          if (frequency[num] > maxFreq) {
              maxFreq = frequency[num];
          }
      }

      // Find all numbers with the highest frequency
      for (let num in frequency) {
          if (frequency[num] === maxFreq) {
              mode.push(Number(num));
          }
      }

      return mode.length === 1 ? mode[0] : mode;
  }
  const browserBack = () =>{
    window.history.back();
  }

  const  removeAfterKey = (str, key) =>{
    const keyIndex = str.indexOf(key);
    if (keyIndex === -1) {
        return str; // Key character not found, return the original string
    }
    return str.substring(0, keyIndex);
  }

  return {
    numberWithCommas,
    arrayFindObjectByProp,
    m2ToAcres,
    cellCount10mToAcres,
    cellCount180mToAcres,
    cellCount250mToAcres,
    cellCount30mToAcres,
    cellCount90mToAcres,
    mToFeet,
    gcd,
    sumArray,
    sigFig,
    titleCase,
    logGAevent,
    saveObjToFile,
    getZscore,
    countOccurrences,
    groupSort,
    groupSortIndividBarArrays,
    arrayMaxExcludingValue,
    getKeyByValue, 
    months,
    sortArrayByOrder,
    isFloat,
    objToBase64,
    base64ToObj,
    roundSigFig,
    getMedian,
    getMean,
    arrayListToString,
    getPropForLargestValue,
    getPropsForLargestValue,
    getBarCategoryWithLargestValue,
    containsSubstring,
    getMode,
    browserBack,
    removeAfterKey, 
    errorMessages,
    setErrorMessages
  };
}
